import useHeroImage from "@/hooks/use-hero-image";
import { cn } from "@/lib/utils";

import DetectiveHeroIcon from "./icons/detective";
import KnightHeroIcon from "./icons/knight";
import RobotHeroIcon from "./icons/robot";
import ThiefHeroIcon from "./icons/thief";
import WizardHeroIcon from "./icons/wizard";

export default function MobileHeroIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const heroIndex = useHeroImage();

  if (heroIndex === -1) {
    return null;
  }

  const orderedHeroIcons = [
    WizardHeroIcon,
    KnightHeroIcon,
    DetectiveHeroIcon,
    RobotHeroIcon,
    ThiefHeroIcon,
  ];

  const HeroIcon = orderedHeroIcons[heroIndex];

  return (
    <HeroIcon
      className={cn("absolute inset-0 size-full", className)}
      {...props}
    />
  );
}
